<template>
    <div class="profilePreview center">
        <img v-if="getUserData.photo" class="thumb" :src="getUserData.photo">
        <h2>{{ getUserData.name }}</h2>
        <a :href="getUserData.email" class="block email">{{ getUserData.email }}</a>
        <router-link to="/settings/edit-profile" class="btn btnThin">{{'components/settings/profile-preview.edit' | trans}}</router-link>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        computed : {
            ...mapGetters(["getUserData"]),
        },
    }
</script>
